import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { BehaviourSubjectService } from '../../shared/services/behaviour-subject.service';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/services/apiService.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { StoreVariableService } from '../store-variable.service';
@Component({
  selector: 'app-advance-filter',
  templateUrl: './advance-filter.component.html',
  styleUrls: ['./advance-filter.component.scss']
})
export class AdvanceFilterComponent implements OnInit,OnDestroy {
 smartFilter:any=[];
 smartFilterNew:any=[];
@Input() level3DataImages:any;
@Input() breadCrumb:any;
@Input() json:any;
@Input() productDetailsData:any;
SearchValue:any;
sub: Subscription = new Subscription();
SmartFIlterCabin = false;
SmartFilterFuel = false;
SmartFilterDeck = false;
SmartFilter = false;
  FifthFilter = false;
  SixthFilter = false;
  MobileFilterFirst = false;
  MobileFilterSecond = false;
  MobileFilterThird = false;
  MobileFilterFourth = false;
  selectedItem: any;
  level2Data: any = [];
  TotalCount_List = []
  productlistdata: any;
  level3data: any[] = [];
  level3DataForward:any=[]
  selectedFilters: any = [];
  id: string;
  val: string;
  val2:string;
  level2name:any;
  productlistdataLength: any;
  level3newImages:any

environment1 = environment.s3bucket.url;
productPrice: any;
vc_number:any;
TotalFIlters = 0
alllevel3:any=[]
selectedLevel2ID: any;
selectedLevel3ID: any;
confAWSUrlStr: any = environment.confAWSurl;
  vals: any[]=[];
  labels: any[]=[];
  constructor(@Inject(PLATFORM_ID) private platformId: Object,private route:ActivatedRoute, private behaviourservice:BehaviourSubjectService,private ApiService: ApiService, private storeservice:StoreVariableService,private router:Router ) { }
  ngOnDestroy(): void {
    this.storeservice.isclick.next(true)
  }
  // level3DataImages:any=[]
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.SearchValue=params['search']
      this.id = params['level1'];
      this.val = params['level2'];
      this.val2=params['level3'];
      this.vc_number=params['vcnumber']
      this.level2name=params['level2name']
    })
    this.storeservice.breadCrumb.l1_actual_name=this.id
    this.storeservice.breadCrumb.l2_actual_name=this.val
    this.storeservice.breadCrumb.l3_actual_name=this.val2

    this.breadCrumb=this.storeservice.breadCrumb

      this.storeservice.vcNumber=this.vc_number
      // this.onsearch(this.id,this.val)
      this.onsearchlevel3(this.id,this.val)

       this.getVehicledetail()


    // this.smartFilter=this.storeservice.smartFilterData
    // if (this.smartFilter?.length == 0) {
    //   this.router.navigate(['advancesearch',this.id,this.val])
    // }

    // this.level3DataImages=this.storeservice.level3DataImages
    // this.productDetailsData=this.storeservice.productDetailsData

    this.breadCrumb=this.storeservice.breadCrumb
    this.json=this.storeservice.json

  }

  onsearch(level1: any, level2: any){
    let data = {
      level1: level1,
      level2: level2,
      level3: '',
        search:''
    };


    this.ApiService.advanceSearch(data).subscribe((res: any) =>{
          if (res.success) {
            localStorage.removeItem('l2SearchData');
            localStorage.removeItem('l3SearchData');
            this.onsearchlevel3(this.id,this.val)

            // this.level2Data=res.data.data
            // for (let index = 0; index < this.level2Data?.length; index++) {
            //   this.getonsearchlevel3(this.id,this.val,index)
            // }

            // if (this.level2Data?.length ==1 ) {
              // this.onclickLevel2(this.storeservice.isclickid,'level2')
              // // this.onSearchClick('', '', level2)
              // this.onsearchlevel3(level1,level2)
            // }




            // this.getLevel2Data(this.val)
          }})
  }
  getonsearchlevel3(level1: any, level2: any,val:any){
    let data = {
      level1: level1,
      level2: level2,
      level3: this.level2Data[val]?.l3_actual_name,
        search:''
    };


    this.ApiService.advanceSearch(data).subscribe((res: any) =>{
          if (res.success) {
            this.alllevel3.push(res.data.data)
            const parentIndex = this.alllevel3.findIndex(subArray =>
              subArray.some(item => item.ppl_display_name === this.val2)
            );
            if (parentIndex >=0) {
              this.onclickLevel2(parentIndex,'level2')
              // this.onSearchClick('', '', level2)
              this.onsearchlevel3(level1,level2)
            }

          }})
  }
  onclickLevel2(id, flag) {
    if (flag == 'level2') {
      this.selectedLevel2ID = id;
    this.storeservice.isclickid=id
    }
    else {
      // this.level3data = []
      this.selectedLevel3ID = id;
    }
  }
  getVehicledetail(){
    if (isPlatformBrowser(this.platformId)) {
      // this.breadCrumb?.l3_actual_name = val.ppl_actual_name
      // this.breadCrumb?.l3_actual_name = val.ppl_display_name
      let data = {
        vehicle_number: this.vc_number
      }
      this.ApiService.getVehicleDetails(data).subscribe({
        next: (res: any) => {

          if (res.success) {

            this.productDetailsData = res.data
            this.getSmartFilterData()

            this.productPrice = this.productDetailsData.price_range

          }
          else {
            // document.getElementById('btnClose1').click();
          }
        }, error: (error: any) => {
          // this.displayModal = false;
          // document.getElementById('btnClose1').click();
        }
      })
    }
  }

  onsearchlevel3(level1: any, level2: any){
    let data = {
      level1: level1,
      level2: level2,
      //  level3: this.level2Data[this.storeservice.isclickid]?.l3_actual_name,
      level3:this.level2name,
        search:''
    };
    this.ApiService.advanceSearch(data).subscribe((res: any) =>{
          if (res.success) {
            this.level3DataForward=res.data.data
            this.level3newImages=res.data
            this.level3data=res.data.data.find(vehicle => vehicle.ppl_display_name === this.val2);
            this.level3DataImages=this.level3data['ppl_image_path']
          }})
  }
  getSmartFilterData() {

    this.breadCrumb.l4_actual_name = "Filter"
    this.smartFilter = [];
    let data={
      "ppl": this.productDetailsData.ppl,
      "lob": this.productDetailsData.lob,
      "application":'',
      "pl":this.productDetailsData.ppl=="Winger" ? this.productDetailsData.pl: '',
      "column_five" : (this.productDetailsData.ppl=="MAV Tippers 28" ||this.productDetailsData.ppl == "Magic"|| this.productDetailsData.ppl=="MAV Tippers 35" ||
       this.productDetailsData.ppl=="ICV Buses" || this.productDetailsData.ppl=="LCV Buses" ||
       this.productDetailsData.ppl=="M&HCV Buses") ? this.productDetailsData.column_five :''

    }
    this.sub.add(this.ApiService.getSmartFilter(data).subscribe({
      next: (res: any) => {
        // this.smartFilter = res.data
        // this.selectedFilters = this.level3data.filter((item: any) => item.ppl_actual_name == this.breadCrumb?.l3_actual_name)

        this.selectedFilters = this.level3DataForward.filter((item: any) => item.ppl_display_name === this.breadCrumb?.l3_actual_name)
        this.smartFilterNew=[]
        const keys = Object.keys(this.selectedFilters[0]);
        for (let j = 0; j < keys?.length; j++) {
          if (this.selectedFilters[0][keys[j]] == "YES") {
            this.smartFilterNew.push({ label: keys[j], data: res.data[keys[j]] })

          }
        }

     const filteredData =  this.smartFilterNew.filter(item => item.data !== undefined && item.data !== null && item.data !=="" && item.data?.length !== 0);
     this.smartFilter = [];
    this.smartFilter=filteredData


     if (this.smartFilter) {
      this.storeservice.smartFilterData=this.smartFilter
      this.storeservice.level3DataImages=this.level3DataImages
      this.storeservice.json=this.json
      this.storeservice.productDetailsData=this.productDetailsData
      this.storeservice.breadCrumb=this.breadCrumb
      // this.router.navigate(['advancesearch1/smart-filter'])
      // this.router.navigate(['advancesearch/',this.storeservice.breadCrumb.l1_actual_name,this.storeservice.breadCrumb.l2_actual_name,this.storeservice.breadCrumb?.l3_actual_name,this.vc_number,'smart-filter']);
     }

     for (let key in this.json) {
      this.json[key] = null;
    }

      }
    }))
  }
  getSmartFilterData2(val: any, label: any) {

        // this.breadCrumb.l4_actual_name = "Filter"
        // this.smartFilter = [];
        let data={
          "ppl": this.productDetailsData.ppl,
          "lob": this.productDetailsData.lob,
          "application":'',
          "pl":this.productDetailsData.ppl=="Winger" ? this.productDetailsData.pl: '',
          "column_five" : (this.productDetailsData.ppl=="MAV Tippers 28" || this.productDetailsData.ppl == "Magic"|| this.productDetailsData.ppl=="MAV Tippers 35" ||
           this.productDetailsData.ppl=="ICV Buses" || this.productDetailsData.ppl=="LCV Buses" ||
           this.productDetailsData.ppl=="M&HCV Buses") ? this.productDetailsData.column_five :'',


        }
     const index = this.vals.indexOf(val);
    if (index !== -1) {
        this.vals.splice(index, 1);
        this.labels.splice(index, 1);
    }
        this.vals.push(val)
        this.labels.push(label)
        for (let i = 0; i < this.vals?.length; i++) {
          if (this.vals[i] && this.labels[i] != null) {
              let val = this.vals[i];
              let label = this.labels[i];
              data[val] = label;
          }
      }
        // let dynamicKey =val ;
        // let dynamicValue =label ;
        // data[dynamicKey] = dynamicValue;
        this.sub.add(this.ApiService.getSmartFilter(data).subscribe({
          next: (res: any) => {
            this.selectedFilters = this.level3DataForward.filter((item: any) => item.ppl_display_name === this.breadCrumb?.l3_actual_name)
            this.smartFilterNew=[]
            const keys = Object.keys(this.selectedFilters[0]);
            for (let j = 0; j < keys?.length; j++) {
              if (this.selectedFilters[0][keys[j]] == "YES") {
                this.smartFilterNew.push({ label: keys[j], data: res.data[keys[j]] })

              }
            }

         let filteredData =[]
         filteredData= this.smartFilterNew.filter(item => item.data !== undefined && item.data !== null && item.data !=="" && item.data?.length !== 0);
         this.smartFilter = [];
        this.smartFilter=filteredData
         if (this.smartFilter) {
          this.storeservice.smartFilterData=this.smartFilter
          this.storeservice.level3DataImages=this.level3DataImages
          this.storeservice.json=this.json
          this.storeservice.productDetailsData=this.productDetailsData
          this.storeservice.breadCrumb=this.breadCrumb
          // this.router.navigate(['advancesearch1/smart-filter'])
          // this.router.navigate(['advancesearch/',this.storeservice.breadCrumb.l1_actual_name,this.storeservice.breadCrumb.l2_actual_name,this.storeservice.breadCrumb?.l3_actual_name,this.vc_number,'smart-filter']);
         }
        //  for (let key in this.json) {
        //   this.json[key] = null;
        // }

          }
        }))
      }
  getProductListData() {
    let data = {
        end_row: 100,
        actual_lob_name: [this.productDetailsData?.lob_seo],
        ppl_name: this.productDetailsData?.ppl_seo =='mcv-lwb' ? ["mcv-lwb", "mcv-lpt-19", "mcv-swb"] : [this.productDetailsData?.ppl_seo],
        pl_name:this.productDetailsData?.ppl_seo === "winger" ? [this.productDetailsData?.pl] :[],
        feature_premium: this.json.feature_premium ? [this.json.feature_premium] : [],
        tyre_type: this.json.tyre_type ? [this.json.tyre_type] : [],
        deck_length: this.json.deck_length ? [this.json.deck_length] : [],
        cabin_type: this.json.cabin_type ? [this.json.cabin_type] : [],
        wheels: this.json.wheels ? [this.json.wheels] : [],
        brand: this.json.brand ? [this.json.brand] : [],
        no_seats: this.json.no_seats ? [this.json.no_seats] : [],
        air_conditioning: this.json.air_conditioning ? [this.json.air_conditioning] : [],
        fuel_type: this.json.fuel_type ? [this.json.fuel_type] : [],
        body_type: this.json.body_type ? [this.json.body_type] : [],
        color: this.json.color ? [this.json.color] : [],
        deck_type: this.json.deck_type ? [this.json.deck_type] : [],
        roof_type: this.json.roof_type ? [this.json.roof_type] : [],
        sleeping_option: this.json.sleeping_option ? [this.json.sleeping_option] : [],
        body_option: this.json.body_option ? [this.json.body_option] : [],
        gvw: this.json.tonnage ? [this.json.tonnage] : [],
        engine_power: this.json.engine_power ? [this.json.engine_power] : [],
        body_size: this.json.body_size ? [this.json.body_size] : [],
        suspension_type: this.json.suspension_type ? [this.json.suspension_type] : [],
        engine_type: this.json.engine_type ? [this.json.engine_type] : [],
        colour: this.json.colour ? [this.json.colour] : [],
        ventilation: this.json.ventilation ? [this.json.ventilation] : [],
        wheel_base: this.json.wheelbase ? [this.json.wheelbase] : [],
        payload: this.json.payload ? [this.json.payload] : [],
        wheel_drive: this.json.wheel_drive ? [this.json.wheel_drive] : [],
        engine:this.json.engine ? [this.json.engine]:[],
        column_five : (this.productDetailsData.ppl=="MAV Tippers 28" || this.productDetailsData.ppl == "Magic"|| this.productDetailsData.ppl=="MAV Tippers 35" ||
        this.productDetailsData.ppl=="ICV Buses" || this.productDetailsData.ppl=="LCV Buses" || this.productDetailsData.ppl=="M&HCV Buses") ?
        this.productDetailsData.column_five ? [this.productDetailsData.column_five] : [] : [],
        RMC_Drum_Size:this.json.RMC_Drum_Size ? [this.json.RMC_Drum_Size] : [],
      }


    // this.filterSmartFilterData(this.smartFilter, this.json);
    const filteredKeys = Object.keys(data).filter(key =>
      data[key]?.length > 0 && key !== "ppl_name" && key !== "actual_lob_name"
    );
    const filteredValues = filteredKeys.map(key => data[key]).flat();
    this.TotalCount_List = filteredValues

    this.sub.add(this.ApiService.getVehicleInfo2(data).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.productlistdata = res.data

          this.productlistdataLength = this.productlistdata?.length
          if ( this.productlistdata?.length>0) {
            this.storeservice.productlistdata=this.productlistdata
            this.storeservice.TotalCount_List=this.TotalCount_List
            this.storeservice.breadCrumb=this.breadCrumb
            this.storeservice.TotalFIlters=this.TotalFIlters
            this.storeservice.smartFilterData=this.smartFilter
            this.storeservice.json=this.json

            this.storeservice.productDetailsData=this.productDetailsData
// this.router.navigate(['advancesearch1/plp-list'])

          }
          // this.router.navigate(['advancesearch1', 'plp-list']);
        }
        else {
          this.productlistdataLength = 0;
          this.productlistdata = [];
        }
        // this.router.navigate(['advancesearch1/plp-list'])
        this.storeservice.isSmart=true
        this.router.navigate(['advancesearch/',this.SearchValue,this.storeservice.breadCrumb.l1_actual_name,this.storeservice.breadCrumb.l2_actual_name,this.level2name,this.storeservice.breadCrumb?.l3_actual_name,this.vc_number,'smart-filter','plp-list']);
      }
    }))
  }
  filterClick(flag, val, id) {

    if (this.selectedItem === val) {
      this.selectedItem = null;
      val = null;
this.getSmartFilterData2(flag,val)

      if (id == 1) {
        this.SmartFilterFuel = false;
      }
      else if (id == 2) {
        this.SmartFilterDeck = false;
      }
      else if (id == 3) {
        this.SmartFIlterCabin = false;
      }
      else if (id == 4) {
        this.SmartFilter = false;
      }

    } else {
this.getSmartFilterData2(flag,val)

      this.selectedItem = val;


      if (id == 1) {

        this.SmartFilterFuel = true;
      }
      else if (id == 2) {
        this.SmartFilterDeck = true;
      }
      else if (id == 3) {
        this.SmartFIlterCabin = true;
      }
      else if (id == 4) {
        this.SmartFilter = true;
      }

    }


    let a = 0;
    if (flag == "deck_length") {
      this.json.deck_length = val;

    }
    else if (flag == "tyre_type") {
      this.json.tyre_type = val;

    }
    else if (flag == "cabin_type") {
      this.json.cabin_type = val;

    }
    else if (flag == "wheels") {
      this.json.wheels = val;

    }
    else if (flag == "feature_premium") {
      this.json.feature_premium = val;

    }
    else if (flag == "brand") {
      this.json.brand = val;

    }
    else if (flag == "no_seats") {
      this.json.no_seats = val;

    }
    else if (flag == "air_conditioning") {
      this.json.air_conditioning = val;

    }
    else if (flag == "fuel_type") {
      this.json.fuel_type = val;

    }
    else if (flag == "body_type") {
      this.json.body_type = val;

    }
    else if (flag == "color") {
      this.json.color = val;

    }
    else if (flag == "deck_type") {
      this.json.deck_type = val;

    }
    else if (flag == "roof_type") {
      this.json.roof_type = val;

    }
    else if (flag == "sleeping_option") {
      this.json.sleeping_option = val;

    }
    else if (flag == "body_option") {
      this.json.body_option = val;

    }
    else if (flag == "tonnage") {
      this.json.tonnage = val;

    }
    else if (flag == "engine_power") {
      this.json.engine_power = val;

    }
    else if (flag == "body_size") {
      this.json.body_size = val;

    }
    else if (flag == "suspension_type") {
      this.json.suspension_type = val;

    }
    else if (flag == "engine_type") {
      this.json.engine_type = val;

    }
    else if (flag == "colour") {
      this.json.colour = val;

    }
    else if (flag == "ventilation") {
      this.json.ventilation = val;

    }
    else if (flag == "wheelbase") {
      this.json.wheelbase = val;

    }
    else if (flag == "payload") {
      this.json.payload = val;

    }
    else if (flag == "wheel_drive") {
      this.json.wheel_drive = val;

    }
    else if (flag == "engine") {
      this.json.engine = val;

    }
    else if (flag == "RMC_Drum_Size") {
      this.json.RMC_Drum_Size = val;

    }
    let count = 0;
    Object.values(this.json).forEach(value => {
      if (value !== null && value !== "") {
        count++;
      }
    });
    this.TotalFIlters = count
    this.behaviourservice.SearchConsoleFilterCount.next(this.TotalFIlters);

    // this.breadCrumb.filterCount = this.sum(this.FilterCount);
  }
  getChildValue(event)
  {
    if (isPlatformBrowser(this.platformId)) {
      if (event == "search1") {
        localStorage.removeItem('l1SearchData')
        localStorage.removeItem('l2SearchData')
        localStorage.removeItem('l3SearchData')
        this.storeservice.breadCrumb.l4_actual_name= ''
        this.storeservice.breadCrumb.l1_actual_name= '';
        this.storeservice.breadCrumb.l2_actual_name='';
        this.storeservice.breadCrumb.l3_actual_name='';
        // this.selectedLevel2ID = '';
        // this.selectedLevel3ID = '';
    }
    else  if (event == "search2") {
    this.storeservice.isclick.next(false)
    localStorage.removeItem('l2SearchData');
    localStorage.removeItem('l3SearchData');
    // this.selectedLevel2ID = '';
    // this.selectedLevel3ID = '';
    this.storeservice.breadCrumb.l2_actual_name = this.breadCrumb.l2_actual_name = '';
    this.storeservice.breadCrumb.l3_actual_name=this.breadCrumb.l3_actual_name = ''
    this.storeservice.breadCrumb.l4_actual_name = this.breadCrumb.l4_actual_name = ''
    this.behaviourservice.SearchConsoleFilterCount.next(0);
  }
  else if (event == "search3") {
    this.storeservice.isclick.next(true)
    // this.CabinTypeFIlter = false;
    // this.FuelTypeFilter = false;
    // this.BodyTypeFilter = false
    // this.DeckLengthFilter = false
    // this.FilterCLicked = false;
    this.FifthFilter = false;
    this.SixthFilter = false;
    this.storeservice.breadCrumb.l3_actual_name = '';
    this.storeservice.breadCrumb.l4_actual_name = ''

    this.behaviourservice.SearchConsoleFilterCount.next(0);
    this.smartFilter = [];
    localStorage.removeItem('l3SearchData');
    // this.brtEstimateTotalEarning_1year = ''


    // this.isDetailsVisible = ''

    // this.selectedLevel2ID = '';

    // this.selectedLevel3ID = '';

    // this.breadCrumb.l2_actual_name = '';


  }
  else if (event == "search4") {
    this.storeservice.isclick.next(true)
    this.storeservice.breadCrumb.l4_actual_name = ''
    this.TotalFIlters = 0
    this.behaviourservice.SearchConsoleFilterCount.next(this.TotalFIlters);
    this.FifthFilter = false;
    this.SixthFilter = false;

  }
  }
  }
  MobileFilter1() {
    this.MobileFilterFirst = true;
    this.MobileFilterSecond = false;
    this.MobileFilterThird = false;
    this.MobileFilterFourth = false;
  }
  MobileFilter2() {
    this.MobileFilterFirst = false;
    this.MobileFilterSecond = true;
    this.MobileFilterThird = false;
    this.MobileFilterFourth = false;
  }
  MobileFilter3() {
    this.MobileFilterFirst = false;
    this.MobileFilterSecond = false;
    this.MobileFilterThird = true;
    this.MobileFilterFourth = false;
  }
  MobileFilter4() {
    this.MobileFilterFirst = false;
    this.MobileFilterSecond = false;
    this.MobileFilterThird = false;
    this.MobileFilterFourth = true;
  }
}
